import Vue from 'vue';
export default Vue.extend({
    name: 'fundTable',
    props: {
        // 表头配置
        tableDataConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        // 合并行/列
        spanMethod: {
            type: Function,
            default: function () { },
        },
        // slot是否是行首
        slotPosition: {
            type: String,
            default: '',
        },
        // 请求配置
        tableRequestConfig: {
            type: Object,
            default: function () {
                return {
                    url: '',
                    method: 'get',
                    inputParam: {},
                };
            },
        },
        // 是否进入页面默认请求一次
        isDefaultRequest: {
            type: Boolean,
            default: true,
        },
        // 单元格内容样式配置
        cellConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        // 筛选条件发生变化触发
        filterChange: {
            type: Function,
            default: function () {
                return function () { };
            },
        },
    },
    data: function () {
        return {
            pageNo: 1,
            pageSize: 20,
            totalItemCount: '',
            tableData: [],
        };
    },
    created: function () {
        this.isDefaultRequest && this.issueRequest();
    },
    methods: {
        // 发起请求
        issueRequest: function () {
            this.getData(this.getParams());
        },
        // 获取请求参数
        getParams: function () {
            var inputParam = this.tableRequestConfig.inputParam;
            var _a = this, pageNo = _a.pageNo, pageSize = _a.pageSize;
            inputParam = inputParam || {};
            return Object.assign({
                pageNo: pageNo,
                pageSize: pageSize,
            }, inputParam);
        },
        // 请求列表数据
        getData: function (params) {
            var _this = this;
            if (params === void 0) { params = {}; }
            var _a = this.tableRequestConfig, url = _a.url, method = _a.method;
            if (!url) {
                return this.$message.error('请配置table组件请求url');
            }
            this.$request({
                url: url,
                method: method,
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode !== 0) {
                    return;
                }
                var pageNo = res.pageNo, pageSize = res.pageSize, totalItemCount = res.totalItemCount, data = res.data;
                _this.pageNo = pageNo;
                _this.pageSize = pageSize;
                _this.totalItemCount = totalItemCount;
                _this.tableData = data;
            });
        },
        currentPage: function (pageNo) {
            this.pageNo = pageNo;
            this.issueRequest();
        },
        btnOpe: function (callback, row) {
            callback && typeof callback === 'function' && callback(row);
        },
        cellStyle: function (_a) {
            var row = _a.row, column = _a.column;
            var cellConfig = this.cellConfig;
            var keys = typeof cellConfig && cellConfig !== null ? Object.keys(cellConfig) : [];
            var styles = '';
            if (keys.length > 0) {
                keys.forEach(function (item) {
                    if (column.property === item) {
                        cellConfig[item].forEach(function (eItem) {
                            var status = eItem.status, style = eItem.style, flag = eItem.flag;
                            if (!flag) {
                                if (row[item] === status) {
                                    styles = style;
                                }
                            }
                            else {
                                row[flag] === status ? (styles = style) : '';
                            }
                        });
                    }
                });
            }
            return styles;
        },
    },
    watch: {
        tableRequestConfig: {
            handler: function () {
                this.pageNo = 1;
                this.issueRequest();
            },
            deep: true,
        },
        tableData: {
            deep: true,
            handler: function (val) {
                this.$emit('get-request-result', {
                    data: val,
                    isHaveData: (val && val.length > 0) || false,
                });
            },
        },
    },
});
